import { render, staticRenderFns } from "./nepaAbout.vue?vue&type=template&id=b39fd9a8&scoped=true"
import script from "./nepaAbout.vue?vue&type=script&lang=js"
export * from "./nepaAbout.vue?vue&type=script&lang=js"
import style0 from "./nepaAbout.vue?vue&type=style&index=0&id=b39fd9a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39fd9a8",
  null
  
)

export default component.exports